var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"bottom":true,"right":true,"value":_vm.show,"timeout":_vm.timeout,"multi-line":""}},[_vm._v(" "+_vm._s(_vm.body)+" "),_c('v-btn',{attrs:{"text":"","color":"pink"},nativeOn:{"click":function($event){_vm.show = false}}},[_vm._v(" Close ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }